export const baseUrl = "https://api.themoviedb.org/3";
export const API_KEY = "1d2e73081e7179596269dba7df57ed5a";
export const imageUrl = "https://image.tmdb.org/t/p/original";
